<template>
  <div>
    <Layout
      :stageTitle="$t(stageTitle)"
      :stageSubTitle="$t(stageSubTitle)"
      footer
    >
      <EditPersonTab4 :formValid.sync="internalValid" />
    </Layout>
  </div>
</template>

<script>
  import EditPersonTab4 from '@/components/RightDrawer/form/PersonTab4'
  import Layout from '@/pages/Subscriber/steps-sub/Layout'

  export default {
    components: {
      Layout,
      EditPersonTab4,
    },
    props: {
      formValid: {
        type: Boolean,
        default: false,
      },
      stageTitle: {
        type: String,
        required: true,
      },
      stageSubTitle: {
        type: String,
        required: true,
      },
    },
    computed: {
      internalValid: {
        get() {
          return this.formValid
        },
        set(value) {
          return this.$emit('update:formValid', value)
        },
      },
    },
  }
</script>
